import { VehicleImageUrls } from "static/js/app/models/vehicleImageUrls";
export function buildVehicleImageThumbnails (images:VehicleImageUrls[], numberOfExtraImages:number): string {
  let numberOfExtraImagesCalc = numberOfExtraImages + 1;
    if (images == null || images.length == 0 || numberOfExtraImages == null || numberOfExtraImages == 0) {
        return "";
    }
    else {
      
      let thumbImages = images.slice(1,numberOfExtraImagesCalc)
                              .map(im=> `<li><img src="${im.i320x240}" class=""></li>`)
                              .join("");
      let thumbs = `<ul class="vehicle-results-thumbnails">${thumbImages}</ul>`;
      return thumbs;
    }
}
export function buildVehicleImageThumbnailsSlick (images:VehicleImageUrls[], numberOfExtraImages:number): string {
    if (images == null || images.length <= 1 || numberOfExtraImages == null || numberOfExtraImages <= 1) {
        return "";
    }
    else {
      
      let thumbImages = images.slice(0,numberOfExtraImages)
                              .map(im=> `<li><img src="${im.i320x240}" data-placeholder="/media/placeholder.jpg"></li>`)
                              .join("");
      let thumbs = `<ul class="slick slick--vehicle-results-thumbnails vehicle-results-thumbnails">${thumbImages}</ul>`;
      return thumbs;
    }
}
